(function() {
  'use strict';

  function PendingSectionsController(
    $rootScope,
    Profile,
    EventSection,
    PendingSectionSearch,
    APIList,
    Utils
  ) {
    var ctrl = this;

    Utils.setPageTitle('Pending sections');

    ctrl.options = {
      highlightField: 'text'
    };

    var listName = 'pending-sections';
    ctrl.options.search = ctrl.searchModel;

    ctrl.searchModel = Profile.getListPreferences(listName).current;

    var makeDocs = function(item) {
      return new EventSection(item);
    };

    var loadSections = function() {
      return ctrl.list.doLoadItems()
        .catch(function(error) {
          Utils.showError(error);
        });
    };

    function setupList(search) {
      ctrl.list = new APIList(null, {
        endpoint: 'es_pending_sections',
        search: search,
        model: ctrl.searchModel,
        makeDocs: makeDocs,
        defaultFilter: {
          state: 'pending'
        }
      });
      return loadSections();
    }

    ctrl.$onInit = function() {
      PendingSectionSearch.search
        .then(function(search) {
          return setupList(search);
        })
        .then(function() {
          ctrl.loaded = true;
          $rootScope.$broadcast('KZCurrentListChange', { list: listName });
        });
    };

    ctrl.actions = [];
  }

  PendingSectionsController.$inject = [
    '$rootScope',
    'ProfileService',
    'EventSectionFactory',
    'PendingSectionSearch',
    'APIListFactory',
    'UtilsService'
  ];

  angular.module('component.admin')
    .component('pendingSections', {
      controller: PendingSectionsController,
      controllerAs: 'pendingCtrl',
      templateUrl: 'app/components/admin/pending-sections.html'
    });
})();
